export const SET_TIMEOFF_LOADING = 'SET_TIMEOFF_LOADING'
export const SET_TIMEOFF = 'SET_TIMEOFF'
export const ADD_TIMEOFF = 'ADD_TIMEOFF'
export const EDIT_TIMEOFF = 'EDIT_TIMEOFF'
export const DELETE_TIMEOFF = 'DELETE_TIMEOFF'
export const EDIT_STATUS_TIMEOFF = 'EDIT_STATUS_TIMEOFF'
